import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAdminAuth } from '../hooks/use-admin-auth.hook';

interface AdminRouteProps {
  component: React.ComponentType<any>;
  layout: React.ComponentType<any>;
  path: string;
  exact?: boolean;
  code?: string;
  [key: string]: any;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ component: Component, layout: Layout, code, ...rest }) => {
  const { isAuthenticated, isAdmin } = useAdminAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) return <Redirect to="/login" />;
        if (!isAdmin) return <Redirect to="/" />;

        return (
          <Layout>
            <Component code={code} {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default AdminRoute;
